import React from "react";
import INFO from "../basic";

export function LEGAL_LINKS () {

    return [
        {
            slug: 'privacy-policy',
            title : {
                ua: 'Політика конфіденційності',
                en: 'Privacy policy'
            },
            icon: '🔒',
            url: INFO.cloudURL
        },
        {
            slug: 'terms-of-use',
            title : {
                ua: 'Правила користування',
                en: 'Terms of use'
            },
            icon: '📔',
            url: INFO.cloudURL
        },
        {
            slug: 'cookie-policy',
            title : {
                ua: 'Політика кукі',
                en: 'Cookie policy'
            },
            icon: '🍪',
            url: INFO.cloudURL
        },
        {
            slug: 'legal-entity',
            title : {
                ua: 'Фізична особа',
                en: 'Legal entity'
            },
            icon: '💼',
            url: INFO.cloudURL
        },
    ];
}

export default LEGAL_LINKS();